import {
  Grid,
  InputAdornment,
  TextField,
} from '@mui/material'
import React from 'react'

const Dose = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <TextField
      label="Dose"
      fullWidth
      InputProps={{
        endAdornment: <InputAdornment position="end">ml</InputAdornment>,
      }}
      value={moduleValues['Dose (ml)']}
      onChange={(e) =>
        setModuleValues((prev) => ({ ...prev, ['Dose (ml)']: e.target.value }))
      }
      type="number"
    />
  </Grid>
)

export default Dose
